import Icon from 'vue-awesome/components/Icon'

Icon.register({
  cell_wifi_rounded: {
    paths: [
      {
        'fill-opacity': '.3',
        d: 'M8.41 22H20c1.1 0 2-.9 2-2V8.39c0-.89-1.08-1.34-1.71-.71L7.7 20.29c-.63.63-.18 1.71.71 1.71z'
      },
      {
        d: 'M7.71 20.29c-.63.63-.19 1.71.7 1.71H18V9.98L7.71 20.29zm1.36-9.22L11 13l1.93-1.93a2.74 2.74 0 00-3.86 0zm-.7-1.77a4.553 4.553 0 015.27 0c.36.26.85.22 1.16-.1.39-.39.35-1.06-.1-1.38a6.402 6.402 0 00-7.4 0c-.45.32-.5.99-.1 1.38a.9.9 0 001.17.1z'
      },
      {
        d: 'M16.21 6.69c.34.28.83.28 1.14-.03l.12-.12c.35-.35.31-.92-.08-1.24-3.67-3.05-9.02-3.07-12.7-.06-.43.35-.47.99-.08 1.37.32.33.84.37 1.19.08 3.01-2.48 7.4-2.48 10.41 0z'
      }
    ],
    width: '24',
    height: '24'
  }
})
